import { render, staticRenderFns } from "./AddProductCategoryModal.vue?vue&type=template&id=b72be45e"
import script from "./AddProductCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddProductCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports